import { api } from "./api";

// Reader-level copy adaptation.
// Levels: 'everyday' | 'founder' | 'insider' (insider = original, no LLM call)
// Models: 'claude' (default, Sonnet 4.6) | 'gpt' (GPT-5.4)

export const READING_LEVELS = [
  {
    key: "everyday",
    label: "Everyday",
    hint: "Plain English. Any founder — jargon explained inline.",
  },
  {
    key: "founder",
    label: "Founder",
    hint: "Standard tone. Assumes basic CPG knowledge.",
  },
  {
    key: "insider",
    label: "Insider",
    hint: "Original copy — the way the CPG Institute wrote it.",
  },
];

export async function adaptCopy({ source, sourceId, level, fields, model }) {
  const r = await api.post("/copy/adapt", {
    source,
    source_id: sourceId,
    level,
    fields,
    model,
  });
  return r.data.adapted;
}

export async function regenerateCopy({ source, sourceId, field, level, originalText, feedback, model }) {
  const r = await api.post("/copy/regenerate", {
    source, source_id: sourceId, field, level,
    original_text: originalText, feedback, model,
  });
  return r.data;
}

// ── Admin ───────────────────────────────────────────────────────────────
export async function adminSuggestCopy({ source, sourceId, field, originalText, audience, styleDirective, model }) {
  const r = await api.post("/admin/copy/suggest", {
    source, source_id: sourceId, field,
    original_text: originalText,
    audience, style_directive: styleDirective, model,
  });
  return r.data;
}

export async function adminApplyCopy({ source, sourceId, field, newText, audience, styleDirective, model }) {
  const r = await api.put("/admin/copy/apply", {
    source, source_id: sourceId, field,
    new_text: newText,
    audience, style_directive: styleDirective, model,
  });
  return r.data;
}

export async function adminCopyInventory(source) {
  const r = await api.get("/admin/copy/inventory", { params: { source } });
  return r.data;
}

export async function adminPurgeCopyCache({ source, sourceId }) {
  const r = await api.delete("/admin/copy/cache", {
    params: { source, ...(sourceId ? { source_id: sourceId } : {}) },
  });
  return r.data;
}

export async function previewCopy({ text, level, model }) {
  const r = await api.post("/copy/adapt/preview", { text, level, model });
  return r.data;
}

export async function setReadingLevel(level) {
  const r = await api.put("/account/reading-level", { level });
  return r.data;
}
